export const COUNTRY_NAMES = {
  TH: 'Thailand',     VN: 'Vietnam',       PH: 'Philippines',  MY: 'Malaysia',
  ID: 'Indonesia',    SG: 'Singapore',     MM: 'Myanmar',      KH: 'Cambodia',
  LA: 'Laos',         BD: 'Bangladesh',    IN: 'India',        CN: 'China',
  JP: 'Japan',        KR: 'South Korea',   AU: 'Australia',    US: 'United States',
  GB: 'United Kingdom', DE: 'Germany',     FR: 'France',       AE: 'UAE',
  SA: 'Saudi Arabia', KW: 'Kuwait',        QA: 'Qatar',        BH: 'Bahrain',
  OM: 'Oman',         ZA: 'South Africa',  NG: 'Nigeria',      NZ: 'New Zealand',
  HK: 'Hong Kong',    TW: 'Taiwan',        MO: 'Macau',        BN: 'Brunei',
  LK: 'Sri Lanka',    NP: 'Nepal',         PK: 'Pakistan',     AF: 'Afghanistan',
  IR: 'Iran',         IQ: 'Iraq',          JO: 'Jordan',       LB: 'Lebanon',
};

export const countryName = (code) => COUNTRY_NAMES[code?.toUpperCase()] || code || '—';
